import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import api from "../api";
import Icon from "../lib/icon";
import ApiImage from "../components/ApiImage";
import ProductStatusBadge from "../components/ProductStatusBadge";
import BackButton from "../components/BackButton";
import Breadcrumbs from "../components/Breadcrumbs";
import Button from "../components/Button";

import "./scss/manager-product.scss";

export default function SellerProductPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [product, setProduct] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    load();
  }, [id]);

  async function load() {
    const { data } = await api.get(`/api/seller/products/${id}`);
    setProduct(data);
  }

  if (!product) return null;

  const gallery = product.photos?.length
    ? product.photos.map(p => p.image)
    : [];

  const allSpecs = [
    ...(product.specifications || []),
    ...(product.filters || [])
  ];

  return (
    <div className="manager-product">

      {/* HEADER */}
      <div className="manager-product__header">
        <BackButton />

        <Breadcrumbs
          items={[
            { label: "Главная", path: "/seller/dashboard" },
            { label: "Товары", path: "/seller/products" },
            { label: product.name }
          ]}
        />
      </div>

      {/* GALLERY */}
      <div className="manager-product__gallery">
        <Swiper
          modules={[Pagination]}
          pagination={{
            clickable: true,
            bulletClass: "manager-product__dot",
            bulletActiveClass: "manager-product__dot--active",
          }}
          onSlideChange={(swiper) =>
            setActiveIndex(swiper.activeIndex)
          }
        >
          {gallery.map((img, i) => (
            <SwiperSlide key={i}>
              <div className="manager-product__gallery-image">
                <ApiImage src={img} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="manager-product__thumbs">
          {gallery.map((img, i) => (
            <div
              key={i}
              className={`manager-product__thumb ${
                activeIndex === i ? "active" : ""
              }`}
            >
              <ApiImage src={img} />
            </div>
          ))}
        </div>
      </div>

      {/* INFO */}
      <div className="manager-product__info">
        <ProductStatusBadge status={product.status} />

        <div className="manager-product__title">
          {product.name}
        </div>

        <div className="manager-product__rating">
          <Icon name="star-filled" width={14} height={14} color="#FE9402" />
          <span>{product.rating ?? 0}</span>
          <span className="count">
            {product.reviewCount ?? 0} оценок
          </span>
        </div>

        <div className="manager-product__price-row">
          <div className="manager-product__price">
            {product.isDiscount ? (
              <>
                <span className="discount">
                  {product.costDiscount} ₽
                </span>
                <span className="old">
                  {product.cost} ₽
                </span>
              </>
            ) : (
              <span>{product.cost} ₽</span>
            )}
          </div>

          {product.bonus > 0 && (
            <div className="manager-product__bonus">
              <Icon name="coin" width={14} height={14} />
              {product.bonus}
            </div>
          )}
        </div>

        {/* 🔴 Причина отказа */}
        {product.status === "cancel" && product.comment && (
          <div className="manager-product__reject-reason">
            <div className="label">Причина отклонения</div>
            <div className="text">{product.comment}</div>
          </div>
        )}

        <Button
          className="btn-primary large"
          onClick={() => navigate(`/seller/product/${product.id}/edit`)}
        >
          Редактировать товар
        </Button>

      </div>

      {/* DESCRIPTION */}
      <div className="manager-product__card">
        <div className="title">Описание</div>
        <div className="text">{product.description}</div>
      </div>

      {/* SPECIFICATIONS */}
      {allSpecs.length > 0 && (
        <div className="manager-product__card">
          <div className="title">Характеристики</div>

          {allSpecs.map((s, i) => (
            <div key={i} className="manager-product__spec-row">
              <span>{s.name || s.filterName}</span>
              <span>{s.label || s.parameter}</span>
            </div>
          ))}
        </div>
      )}

    </div>
  );
}
